export default function() {
  setTimeout(() => {
      window.google.maps.event.addDomListener(window, 'load', initMap());
  }, 500)

  function initMap() {
      const block = $('.location-map-wrapper')
      const container = block.find('.map')
      const locations = JSON.parse(JSON.stringify(block.data('locations')))
      const styles = JSON.parse(JSON.stringify(block.data('style')))
      let map = new window.google.maps.Map(container[0], {
          zoom: 9,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          center: new window.google.maps.LatLng(locations.lat, locations.lng),
          mapTypeId: window.google.maps.MapTypeId.ROADMAP,
          mapTypeControlOptions: {
              mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
          },
      })
      const styledMapType = new window.google.maps.StyledMapType(styles)
      map.mapTypes.set('styled_map', styledMapType);
      map.setMapTypeId('styled_map');

      refreshMap(map, locations);
      zoomMap(map);
  }

  function refreshMap(map, location) {
      let markers = [];
      
    let obj = location;
    // let markerImage = {
    //     url: '',
    //     size: new window.google.maps.Size(70, 76),
    //     origin: new window.google.maps.Point(0, 0),
    //     scaledSize: new window.google.maps.Size(60, 65),
    // };

    let marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(obj.lat, obj.lng),
        title: obj.title,
        //icon: markerImage,
    });

    window.google.maps.event.addListener(marker, 'click', function(){
        map.panTo(this.getPosition());
        map.setZoom(13);
    })

    infoWindow(obj, marker);
    markers.push(marker);

      new window.MarkerClusterer(map, markers, {
          maxZoom: 12,
          gridSize: 50,
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      });

  }

  function infoWindow(obj, marker) {
      const directions = 'https://www.google.com.au/maps/dir/' + obj.address['lat'] + ',' + obj.address['lng'];
      const phone = (obj.phone) ? '<p>Ph. ' + obj.phone + '</p>' : '';
      const content = '<div class="pin-content">' +
          '<h3 class="large-text">' + obj.title + '</h3><p>' +
          obj.address['address'] + '</p>' + phone +
          '<a href="' + directions +
          '" target="_blank">Get Directions</a></div>';

      const infoWindow = new window.google.maps.InfoWindow({
          content: content,
      });

      marker.addListener('click', function () {

          if (Map.info) {
              Map.info.close();
          }

          Map.info = infoWindow;

          infoWindow.open(this.map, marker);
      });
  }

  function zoomMap(map) {
      window.google.maps.event.addListener(map, 'zoom_changed', function () {
          if (this.getZoom() < 2) {
              this.setZoom(2);
          }
      });
  }
}



// WEBPACK FOOTER //
// ./scripts/builder/location-map.js